import React from 'react';
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Typography, Stack,
} from '@mui/material';
import { currency } from './format';

// Lender roll-up table. rows: [{ lender, totalFundings, fundingCount,
// totalCommissions, commissionCount, clientCount }]
export default function LenderSummary({ rows = [], onSelect }) {
  const totals = rows.reduce(
    (acc, r) => ({
      totalFundings: acc.totalFundings + (r.totalFundings || 0),
      totalCommissions: acc.totalCommissions + (r.totalCommissions || 0),
      fundingCount: acc.fundingCount + (r.fundingCount || 0),
    }),
    { totalFundings: 0, totalCommissions: 0, fundingCount: 0 }
  );

  return (
    <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            {['Lender', 'Clients', 'Fundings', 'Total Funded', 'Commissions', 'Total Commission'].map((h, i) => (
              <TableCell key={h} align={i === 0 ? 'left' : 'right'} sx={{ fontWeight: 700, fontSize: '0.75rem', whiteSpace: 'nowrap' }}>
                {h}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => (
            <TableRow
              key={r.lender}
              hover
              sx={{ cursor: onSelect ? 'pointer' : 'default' }}
              onClick={() => onSelect?.(r.lender)}
            >
              <TableCell>
                <Typography variant="body2" fontWeight={600}>{r.lender}</Typography>
              </TableCell>
              <TableCell align="right">{r.clientCount}</TableCell>
              <TableCell align="right">{r.fundingCount}</TableCell>
              <TableCell align="right">{currency(r.totalFundings)}</TableCell>
              <TableCell align="right">{r.commissionCount}</TableCell>
              <TableCell align="right">
                <Typography variant="body2" fontWeight={700} color="success.main">{currency(r.totalCommissions)}</Typography>
              </TableCell>
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={6} align="center" sx={{ py: 4, color: 'text.secondary' }}>No lenders found</TableCell>
            </TableRow>
          )}
          {rows.length > 0 && (
            <TableRow sx={{ bgcolor: '#f8fafc' }}>
              <TableCell><Typography variant="body2" fontWeight={700}>Total ({rows.length} lenders)</Typography></TableCell>
              <TableCell />
              <TableCell align="right"><Typography variant="body2" fontWeight={700}>{totals.fundingCount}</Typography></TableCell>
              <TableCell align="right"><Typography variant="body2" fontWeight={700}>{currency(totals.totalFundings)}</Typography></TableCell>
              <TableCell />
              <TableCell align="right"><Typography variant="body2" fontWeight={700} color="success.main">{currency(totals.totalCommissions)}</Typography></TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
